import React from "react";

import { Container } from "reactstrap";
import {useTranslation} from "react-i18next";

import Values from "./Values";
import Problems from "./Problems";
import Results from "./Results";
import Sales from "./Sales";
import HeroSection from '../../common/HeroSection';
import heroHomeImg from '../../../assets/images/heroHome.png';

import './style.scss'; 

export default function Home () {
    const {t} = useTranslation("common");

    return (
        <Container fluid className="home-page">
            <HeroSection
                title={t('title')}
                description={'Welcome to DevsMore, your trusted partner for scalable IT solutions. We provide skilled developers, UX/UI designers, and quality assurance experts tailored to your unique needs. Our promise: flexible staffing, transparent communication, and a commitment to quality—delivering exactly what you require.'}
                icon={heroHomeImg}
            />
            <Values/>
            <Problems/>
            <Results/>
            <Sales/>
        </Container>
    )
}
